module.exports = __webpack_public_path__ + "img/5_52.cf09120f.png";